// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --component-font-size: 12px;
  --inline-message-font-size: 0.7rem;
  --input-height: 1.8rem;
  --dropdown-font-size: 0.8rem;
  --edited-light-bg: #bfe7cb;
  --edited-dark-bg: #062719;
  --red-600: #dc2626; /* Tailwind's red-600 */
}

.p-fluid .p-inputtext {
  width: 100%;
  height: var(--input-height);
}

.p-calendar-w-btn-right .p-datepicker-trigger {
  height: var(--input-height);
  background-color: transparent !important;
  border: 1px solid var(--surface-border);
  box-shadow: none !important;
  color: inherit;
}

/* Edited Row Styles */
.edited-row {
  background-color: var(--edited-light-bg);
}

.dark-edited-row {
  background-color: var(--edited-dark-bg);
}

.p-inline-message .p-inline-message-text {
  font-size: var(--inline-message-font-size);
}

.p-datatable.p-datatable-sm .p-datatable-tbody > tr > td {
  padding: 0.2rem 0.2rem;
}

.p-datatable.p-datatable-sm .p-datatable-thead > tr > th {
  padding: 0.25rem 0.25rem;
}

/* Global Component Styles */
.p-component {
  font-size: var(--component-font-size);
}

.p-dropdown .p-dropdown-label {
  font-size: var(--component-font-size);
  display: flex;
  align-items: center;
}

.p-panel-header {
  max-height: 1rem;
  background: linear-gradient(
    to bottom,
    var(--primary-200),
    var(--primary-500)
  );
}

/* Target the DataTable scroll wrapper */
::-webkit-scrollbar {
  width: 8px; /* Adjust scrollbar width */
  height: 8px; /* For horizontal scrolling */
}

/* Scrollbar Track */
::-webkit-scrollbar-track {
  background: var(--gray-900);
  border-radius: 10px;
}

/* Scrollbar Thumb */
::-webkit-scrollbar-thumb {
  background: var(--gray-500);
  border-radius: 10px;
}

/* Scrollbar on Hover */
::-webkit-scrollbar-thumb:hover {
  background: var(--color-gray-500); /* Darker color on hover */
}

.p-label {
  font-size: var(--component-font-size);
}

.custom-height {
  height: var(--input-height);
}

.p-column-filter-clear-button {
  display: none !important;
}

.p-datatable.p-datatable-gridlines .p-paginator-bottom {
  display: flex;
  height: 2rem;
  align-content: center;
}
.p-paginator .p-dropdown {
  margin-left: 0.5rem;
  height: 1.5rem;
}

/* Remove fixed height on mobile screens */
@media (max-width: 768px) {
  .p-datatable.p-datatable-gridlines .p-paginator-bottom {
    height: auto !important;
    align-items: flex-start;
  }

  .p-paginator .p-dropdown {
    height: auto !important;
  }
}

.p-fieldset-legend {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  font-size: 0.74rem;
}

.p-fieldset-toggleable {
  border: 1px solid var(--surface-border);
  border-radius: 0.5rem;
  transition: all 0.3s ease;
}

.beo-autocomplete .p-button {
  background: transparent !important;
  border: 1px solid var(--surface-d);
  color: inherit !important;
  box-shadow: none !important;
}

.beo-autocomplete .p-button:hover {
  background: transparent !important;
  color: inherit !important;
}

/* Force the password wrapper to be full width */
.p-password.p-component.p-inputwrapper {
  display: flex; /* override inline-flex */
  width: 100% !important;
  align-content: center;
}

/* Force the input inside to fill */
.p-password-input {
  width: 100% !important;
  height: var(--input-height);
}

/* Optional: also ensure icon field wrapper is width-full */
.p-password .p-icon-field {
  width: 100% !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/css/common/general.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,sBAAsB;EACtB,4BAA4B;EAC5B,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB,EAAE,uBAAuB;AAC7C;;AAEA;EACE,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;EACxC,uCAAuC;EACvC,2BAA2B;EAC3B,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,wCAAwC;AAC1C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,4BAA4B;AAC5B;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB;;;;GAIC;AACH;;AAEA,wCAAwC;AACxC;EACE,UAAU,EAAE,2BAA2B;EACvC,WAAW,EAAE,6BAA6B;AAC5C;;AAEA,oBAAoB;AACpB;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,iCAAiC,EAAE,0BAA0B;AAC/D;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,0CAA0C;AAC1C;EACE;IACE,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,kCAAkC;EAClC,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA,gDAAgD;AAChD;EACE,aAAa,EAAE,yBAAyB;EACxC,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA,mCAAmC;AACnC;EACE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA,2DAA2D;AAC3D;EACE,sBAAsB;AACxB","sourcesContent":[":root {\n  --component-font-size: 12px;\n  --inline-message-font-size: 0.7rem;\n  --input-height: 1.8rem;\n  --dropdown-font-size: 0.8rem;\n  --edited-light-bg: #bfe7cb;\n  --edited-dark-bg: #062719;\n  --red-600: #dc2626; /* Tailwind's red-600 */\n}\n\n.p-fluid .p-inputtext {\n  width: 100%;\n  height: var(--input-height);\n}\n\n.p-calendar-w-btn-right .p-datepicker-trigger {\n  height: var(--input-height);\n  background-color: transparent !important;\n  border: 1px solid var(--surface-border);\n  box-shadow: none !important;\n  color: inherit;\n}\n\n/* Edited Row Styles */\n.edited-row {\n  background-color: var(--edited-light-bg);\n}\n\n.dark-edited-row {\n  background-color: var(--edited-dark-bg);\n}\n\n.p-inline-message .p-inline-message-text {\n  font-size: var(--inline-message-font-size);\n}\n\n.p-datatable.p-datatable-sm .p-datatable-tbody > tr > td {\n  padding: 0.2rem 0.2rem;\n}\n\n.p-datatable.p-datatable-sm .p-datatable-thead > tr > th {\n  padding: 0.25rem 0.25rem;\n}\n\n/* Global Component Styles */\n.p-component {\n  font-size: var(--component-font-size);\n}\n\n.p-dropdown .p-dropdown-label {\n  font-size: var(--component-font-size);\n  display: flex;\n  align-items: center;\n}\n\n.p-panel-header {\n  max-height: 1rem;\n  background: linear-gradient(\n    to bottom,\n    var(--primary-200),\n    var(--primary-500)\n  );\n}\n\n/* Target the DataTable scroll wrapper */\n::-webkit-scrollbar {\n  width: 8px; /* Adjust scrollbar width */\n  height: 8px; /* For horizontal scrolling */\n}\n\n/* Scrollbar Track */\n::-webkit-scrollbar-track {\n  background: var(--gray-900);\n  border-radius: 10px;\n}\n\n/* Scrollbar Thumb */\n::-webkit-scrollbar-thumb {\n  background: var(--gray-500);\n  border-radius: 10px;\n}\n\n/* Scrollbar on Hover */\n::-webkit-scrollbar-thumb:hover {\n  background: var(--color-gray-500); /* Darker color on hover */\n}\n\n.p-label {\n  font-size: var(--component-font-size);\n}\n\n.custom-height {\n  height: var(--input-height);\n}\n\n.p-column-filter-clear-button {\n  display: none !important;\n}\n\n.p-datatable.p-datatable-gridlines .p-paginator-bottom {\n  display: flex;\n  height: 2rem;\n  align-content: center;\n}\n.p-paginator .p-dropdown {\n  margin-left: 0.5rem;\n  height: 1.5rem;\n}\n\n/* Remove fixed height on mobile screens */\n@media (max-width: 768px) {\n  .p-datatable.p-datatable-gridlines .p-paginator-bottom {\n    height: auto !important;\n    align-items: flex-start;\n  }\n\n  .p-paginator .p-dropdown {\n    height: auto !important;\n  }\n}\n\n.p-fieldset-legend {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 24px;\n  font-size: 0.74rem;\n}\n\n.p-fieldset-toggleable {\n  border: 1px solid var(--surface-border);\n  border-radius: 0.5rem;\n  transition: all 0.3s ease;\n}\n\n.beo-autocomplete .p-button {\n  background: transparent !important;\n  border: 1px solid var(--surface-d);\n  color: inherit !important;\n  box-shadow: none !important;\n}\n\n.beo-autocomplete .p-button:hover {\n  background: transparent !important;\n  color: inherit !important;\n}\n\n/* Force the password wrapper to be full width */\n.p-password.p-component.p-inputwrapper {\n  display: flex; /* override inline-flex */\n  width: 100% !important;\n  align-content: center;\n}\n\n/* Force the input inside to fill */\n.p-password-input {\n  width: 100% !important;\n  height: var(--input-height);\n}\n\n/* Optional: also ensure icon field wrapper is width-full */\n.p-password .p-icon-field {\n  width: 100% !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
